import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	heading: {
		fontWeight: 700
	},

	uppercase: {
		textTransform: "uppercase"
	}
}));

function Heading(props) {
	let classes = styles(),
		{className, title, uppercase} = props,
		cls = `${classes.heading} ${className}`;

	return (
		<Typography className={`${cls} ${uppercase ? classes.uppercase : ""}`}>{title}</Typography>
	);
}

Heading.defaultProps = {
	uppercase: false
};

Heading.propTypes = {
	title: PropTypes.string,
	className: PropTypes.string,
	uppercase: PropTypes.bool
};

export default Heading;